import type { SlotData } from './types';

// This store is not redux and is mutable to no cause performance overhead on mousemove
interface SlotOpenerState {
  availableSlot: SlotData | null;
  allSlotsInContainer: SlotData[];
}

const store: SlotOpenerState = {
  availableSlot: null,
  allSlotsInContainer: [],
};

export const getAvailableSlot = () => store.availableSlot;
export const setAvailableSlot = (slot: SlotData) =>
  (store.availableSlot = slot);

export const getAllSlotsInContainer = () => store.allSlotsInContainer;
export const setAllSlotsInContainer = (slots: SlotData[]) =>
  (store.allSlotsInContainer = slots);
